import advanceDecline from "../../../../assets/img/landing/advance-decline.png";
import marketMovers from "../../../../assets/img/landing/market-movers.png";
import futuresEODAnalysis from "../../../../assets/img/landing/eod-scanner.png";
import optionChain from "../../../../assets/img/landing/option-chain.png";
import tradeFinder from "../../../../assets/img/landing/trade-finder.png";
import optionAction from "../../../../assets/img/landing/option-action.png";
import optionsDashboard from "../../../../assets/img/landing/options-dashboard.png";
import seasonality from "../../../../assets/img/landing/seasonality.png";
import analyticsDashboard from "../../../../assets/img/landing/analytics-dashboard.png";
import optionChainCharts from "../../../../assets/img/landing/option-chain-charts.png";
import timeBasedOiAnalysis from "../../../../assets/img/landing/option-oi.png";
import openInterestAnalysis from "../../../../assets/img/landing/oi-analysis.png";
import marketMakerAnalysis from "../../../../assets/img/landing/market-maker-analysis.png";
import volatilityAnalysis from "../../../../assets/img/landing/volatality-analysis.png";
import optionsDashboardCharts from "../../../../assets/img/landing/options-dashboard-charts.png"; 
import putCallRatioChartsOiTrend from "../../../../assets/img/landing/pcr-oi-trend.png";
import rollingAtmStraddleCharts from "../../../../assets/img/landing/rolling-atm-straddle.png";
import dynamicAtmStraddleCharts from "../../../../assets/img/landing/dynamic-atm-straddle.png";
import watchlists from "../../../../assets/img/landing/watchlists.png";
import strikeWiseStraddleTable from "../../../../assets/img/landing/straddle-table.png";
import strikeWiseStraddleCharts from "../../../../assets/img/landing/straddle-charts.png";
import strikeWiseStrangleTable from "../../../../assets/img/landing/strangle-table.png";
import strikeWiseStrangleCharts from "../../../../assets/img/landing/strangle-charts.png";
import multiChartStraddleCharts from "../../../../assets/img/landing/multi-straddle-charts.png";
import multiChartStrangleCharts from "../../../../assets/img/landing/multi-strangle-charts.png";
import multiStrikePriceCharts from "../../../../assets/img/landing/multistrike-price-charts.png";
import multiStrikeOiCharts from "../../../../assets/img/landing/multistrike-oi-charts.png";
import atmStraddlePrices from "../../../../assets/img/landing/atm-straddle-prices.png";
import sectoralStocksAnalysis from "../../../../assets/img/landing/nse-sector-constituents.png";
import netNewHighsLows from "../../../../assets/img/landing/new-highs-lows.png";
import participantWiseOpenInterest from "../../../../assets/img/landing/participant-oi.png";
import highsLowsHeatmap from "../../../../assets/img/landing/highs-lows-heatmap.png";
import cashActivity from "../../../../assets/img/landing/cash-activity.png";
import indexActivity from "../../../../assets/img/landing/fiidii-index-activity.png";
import banListAndMwplLimits from "../../../../assets/img/landing/mwpl-banlist.png";
import marketHolidayList from "../../../../assets/img/landing/holiday-list.png";
import advanceCharts from "../../../../assets/img/landing/advance-charts.png";
import straddleCharts from "../../../../assets/img/landing/straddle-adv-charts.png"
import strangleCharts from "../../../../assets/img/landing/strangle-adv-charts.png"
export const discoverFeatures = [
    {
      id: "analytics-dashboard",
      title: "Analytics Dashboard",
      description:
        "Widget based multi layout dashboard to analyse the markets your way.",
      images: [
        {
          file: analyticsDashboard,
        },
      ],
    },
    {
      id: "advance-decline",
      title: "Advance / Decline (FNO Stocks / Sectoral Indices)",
      description:
        "Quick way to see how the markets are performing and to see strongest/weakest stocks/sectors.",
      images: [
        {
          file: advanceDecline,
        },
      ],
    },
    {
      id: "fno-scanner",
      title: "FNO Scanner (Market Movers)",
      description:
        "Real time scanner to find the stocks that’s matching your criteria.",
      images: [
        {
          file: marketMovers,
        },
      ],
    },
    {
      id: "trade-finder",
      title: "Trade Finder (Multi Charts)",
      description:
        "Monitor multiple stocks & indices to find your high probability setup in real time.",
      images: [
        {
          file: tradeFinder,
        },
      ],
    },
    {
      id: "eod-scanner",
      title: "EOD Scanner",
      description:
        "Analyse EOD charts based on price, oi, delivery, etc to filter your watchlist stocks for the next day.",
      images: [
        {
          file: futuresEODAnalysis,
        },
      ],
    },
    {
      id: "advance-charts",
      title: "Advance Charts",
      description: "Tradingview Charts, Multi Layouts, Unlimited Indicator/Chart templates with 100+ indicators and 80+ drawing tools.",
      images: [
        {
          file: advanceCharts 
        }
      ]
    },
    {
      id: "seasonality",
      title: "Seasonality",
      description:
        "Each stock or Index has a favourable month in a year, find that unique pattern through seasonality analysis.",
      images: [
        {
          file: seasonality,
        },
      ],
    },
    {
      id: "option-chain",
      title: "Advanced Option Chain",
      description:
        "One place to quickly understand about the direction, strength of the underlying and the support and resistance areas though options data.",
      images: [
        {
          file: optionChain,
        },
      ],
    },
    {
      id: "option-chain-charts",
      title: "Option Chain Charts",
      description:
        "Trade options confidently by monitoring Call and Put option charts of multiple strikes in single view. Elevate your options trading with real time option chain charts.",
      images: [
        {
          file: optionChainCharts,
        },
      ],
    },
    {
      id: "option-action",
      title: "Option Action",
      description:
        "View Open Interest, Open Interest Change, Volume and Price for all the strikes and find the active support and resistance and active strikes for trading.",
      images: [
        {
          file: optionAction,
        },
      ],
    },
    {
      id: "time-based-oi-analysis",
      title: "Time based OI Analysis",
      description:
        "Analyse open interest based on certain time, from the reversal zones, from specific times.",
      images: [
        {
          file: timeBasedOiAnalysis,
        },
      ],
    },
    {
      id: "open-interest-analysis",
      title: "Open Interest Analysis",
      description:
        "Time based Open Interest in single view to view OI additions, unwinding’s, total Open Interest changes between specific timestamps.",
      images: [
        {
          file: openInterestAnalysis,
        },
      ],
    },
    {
      id: "market-maker-analysis",
      title: "Gamma Exposure, Delta Exposure (Market maker Analysis)",
      description:
        "Analyse how the market maker’s option positions gives clues to the market movements by analysing the gamma exposure (GeX) and delta exposures (DeX).",
      images: [
        {
          file: marketMakerAnalysis,
        },
      ],
    },
    {
      id: "volatility-analysis",
      title: "Volatility Analysis",
      description:
        "Analyse strike wise implied volatility (IV) and IV curves of multiple expiries to find your perfect IV based trades.",
      images: [
        {
          file: volatilityAnalysis,
        },
      ],
    },
    {
      id: "options-dashboard",
      title: "Options Dashboard",
      description:
        "Cumulative options data analysis comprising of selected strikes cumulative Price, OI.",
      images: [
        {
          file: optionsDashboard,
        },
      ],
    },
    {
      id: "options-dashboard-charts",
      title: "Options Dashboard in Charts view",
      description:
        "One dashboard to understand Price, OI and Decay behaviour of options. You don’t need anything else to trade options confidently.",
      images: [
        {
          file: optionsDashboardCharts,
        },
      ],
    },
    {
      id: "put-call-ratio-charts-oi-trend",
      title: "Put-Call Ratio Charts & OI Trend",
      description:
        "Cumulative PCR and Open Interest Trend charts to confirm and validate the market movements.",
      images: [
        {
          file: putCallRatioChartsOiTrend,
        },
      ],
    },
    {
      id: "rolling-atm-straddle-charts",
      title: "Rolling ATM Straddle Charts",
      description:
        "Real-time, candlestick based, which shows ATM strike rotations for you to trade Non-Directional Vega/Gamma based trades confidently.",
      images: [
        {
          file: rollingAtmStraddleCharts,
        },
      ],
    },
    {
      id: "dynamic-atm-straddle-charts",
      title: "Dynamic ATM Straddle Charts",
      description:
        "Plot Rolling ATM Straddle Charts for all FNO Stocks and all indices. Major indices and stocks will show real-time candlesticks, others show 1min line charts.",
      images: [
        {
          file: dynamicAtmStraddleCharts,
        },
      ],
    },
    {
      id: "watchlists",
      title: "Watchlists",
      description:
        "Unlimited custom watchlist creations, and sector, industry wise predefined watchlists.",
      images: [
        {
          file: watchlists,
        },
      ],
    },
    {
      id: "strike-wise-straddle-table",
      title: "Strike-wise Straddle Table",
      description:
        "See the real time straddle prices along with call and put prices. ",
      images: [
        {
          file: strikeWiseStraddleTable,
        },
      ],
    },
    {
      id: "strike-wise-straddle-charts",
      title: "Strike-wise Straddle Charts",
      description:
        "Switch between Table/Charts view to see the strike wise straddles for any instruments.",
      images: [
        {
          file: strikeWiseStraddleCharts,
        },
      ],
    },
    {
      id: "strike-wise-strangle-table",
      title: "Strike-wise Strangle Table",
      description:
        "Visualize strike wise strangle prices real time in table format, including call/put prices to find your non-directional trades.",
      images: [
        {
          file: strikeWiseStrangleTable,
        },
      ],
    },
    {
      id: "strike-wise-strangle-charts",
      title: "Strike-wise Strangle Charts",
      description:
        "Visualize strike wise strangle charts, including call/put charts to find your high probable non-directional trades.",
      images: [
        {
          file: strikeWiseStrangleCharts,
        },
      ],
    },
    {
      id: "multi-strike-price-charts",
      title: "Multi Strike Price Charts",
      description:
        "Select any option strike to view the price chart in real time and also see the combined prices of selected strikes.",
      images: [
        {
          file: multiStrikePriceCharts,
        },
      ],
    },
    {
      id: "multi-strike-oi-charts",
      title: "Multi-Strike OI/OI Change, PCR, IV charts",
      description:
        "Visualize strike-wise OI/OI change, Implied Volatility, Put Call Ratio charts.",
      images: [
        {
          file: multiStrikeOiCharts,
        },
      ],
    },
    {
      id: "straddle-charts",
      title: "Strike-wise Straddle Charts",
      description:
      "Real-time, Candlesticks strike-wise Straddle charts with multiple indicator support",
      images: [
        {
          file: straddleCharts
        }
      ]
    },
    {
      id: "strangle-charts",
      title: "Strike-wise Strangle Charts",
      description: "Real-time, Candlesticks strike-wise Strangle charts with multiple indicator support",
      images: [
        {
          file: strangleCharts
        }
      ]
    },
    {
      id: "multi-chart-straddle-charts",
      title: "Multi-Chart Straddle Charts",
      description:
        "Visualize and track multiple straddle charts.",
      images: [
        {
          file: multiChartStraddleCharts,
        },
      ],
    },
    {
      id: "multi-chart-strangle-charts",
      title: "Multi-Chart Strangle Charts",
      description: 
      "Visualize and track multiple strangle charts.",
      images: [
        {
          file: multiChartStrangleCharts,
        },
      ],
    },
    {
      id: "atm-straddle-prices",
      title: "ATM Straddle prices of all FNO stocks.",
      description:
        "At-the-Money straddle prices of all the FNO Stocks/Indices.",
      images: [
        {
          file: atmStraddlePrices,
        },
      ],
    },
    {
      id: "sectoral-stocks-analysis",
      title: "Sectoral Stocks Analysis",
      description:
        "Analyse stocks and sectoral indices and find the stocks from strongest sectors for your next trades",
      images: [
        {
          file: sectoralStocksAnalysis,
        },
      ],
    },
    {
      id: "net-new-highs-lows",
      title: "Net New Highs & Lows for all FNO Stocks.",
      description:
        "True real time advance/decline based on stocks hitting new intraday highs and lows. (price action based market breadth analysis)",
      images: [
        {
          file: netNewHighsLows,
        },
      ],
    },
    {
      id: "highs-lows-heatmap",
      title: "Highs & Lows Heatmap for all FNO Stocks.",
      description:
        "True real time advance/decline based on stocks hitting new intraday highs and lows. (price action based market breadth analysis)",
      images: [
        {
          file: highsLowsHeatmap,
        },
      ],
    },
    {
      id: "fii-dii-cash-activity",
      title: "FII / DII – Cash Activity",
      description:
        "See how much money is moving into/out of the cash markets by FIIs & DIIs.",
      images: [
        {
          file: cashActivity,
        },
      ],
    },
    {
      id: "fii-dii-index-activity",
      title: "FII/DII – Index Activity",
      description:
        "See how much contracts are being traded on the indices by FII/DIIs.",
      images: [
        {
          file: indexActivity,
        },
      ],
    },
    {
      id: "participant-wise-open-interest",
      title: "Participant wise Open Interest",
      description:
        "View participant wise open interest among Client/Pro/DII/FII and understand whether they are creating bullish or bearish sentiments.",
      images: [
        {
          file: participantWiseOpenInterest,
        },
      ],
    },
    {
      id: "ban-list-and-mwpl-limits",
      title: "Ban List and MWPL Limits",
      description:
        "See the stocks that are banned for tomorrow's trade in Futures & Options and see Market wise position limits for each stocks to identify potential ban stocks.",
      images: [
        {
          file: banListAndMwplLimits,
        },
      ],
    },
    {
      id: "market-holiday-list",
      title: "Market Holiday List",
      description:
        "See the Holiday list of Indian Markets.",
      images: [
        {
          file: marketHolidayList,
        },
      ],
    },
  ];